import React from 'react';
import './Downloadconnct.css';
import Seo from '../seo/Seo';
import Breadcrumbs from './Breadcrumbs';

const Downloadconnct = () => {
  return (
    <div className="wrapper" style={{marginTop:'130px'}}>
      <Seo
        title="Download the Connct App | Connct"
        description="Scan the QR code to download the Connct app for iPhone or Android and share your digital business card."
        path="/download-connct"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Download", path: "/download-connct" },
        ]}
      />
      <div className="container section text-center">
        <Breadcrumbs
          items={[
            { name: "Home", path: "/" },
            { name: "Download", path: "/download-connct" },
          ]}
        />
        <h1 className="h3" style={{fontSize:'29px',fontWeight:'bold'}}>Scan with your phone to download Connct</h1>
        <div className="scan-block mt-4">
          <img src={require('../assets/images/scan_to_downoad_app.png')} alt="QR code to download the Connct app" width={135} height={135} />
        </div>
      </div><br/><br/>
    </div>
  );
};

export default Downloadconnct;
